import React from 'react';
import { MessageCircleIcon, PhoneIcon } from 'lucide-react';
import { contact } from '../data/contact';
export function MobileActionBar() {
  return <div className="sticky top-16 z-30 border-b border-gold/25 bg-ink/95 px-3 py-2.5 backdrop-blur-md sm:hidden" data-id="element-139" data-mp="auu8hy4rlsmf">
      <div className="flex justify-center gap-3" data-id="element-140" data-mp="esi8vgp88dlp">
        <a href={contact.whatsappHref} target="_blank" rel="noreferrer" className="folder-tab flex min-h-[48px] flex-1 items-center justify-center gap-2 bg-emerald font-display text-[0.68rem] font-semibold uppercase tracking-[0.16em] text-paper" aria-label={`Hablar por WhatsApp al ${contact.whatsapp}`} data-id="element-141" data-mp="jscub4q8gazd">
          <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-142" data-mp="ua3qli1e5zg" />
          WhatsApp
        </a>
        <a href={contact.phoneHref} className="folder-tab flex min-h-[48px] flex-1 items-center justify-center gap-2 border border-gold/70 font-display text-[0.68rem] font-semibold uppercase tracking-[0.16em] text-gold" aria-label={`Llamar al ${contact.phone}`} data-id="element-143" data-mp="2zktp1bm89io6">
          <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-144" data-mp="1aiisrkqang8g" />
          Llamar
        </a>
      </div>
    </div>;
}